// import { Select } from 'antd'
import React from 'react'
import SelectField from '../../../../components/SelectField/SelectField'
import UpcomingEvents from './partials/Upcoming'
import {
  Container,
  LeftSection,
  RightSection,
  SectionWrapper,
  StyledButton1,
} from './style'

const sortByOption = [
  { label: 'Show All', value: 'showAll' },
  { label: 'Recently Added', value: 'forRecentlyAdded' },
  { label: 'Date-wise', value: 'dateWise' },
  { label: 'Registration Events', value: 'forRegisterEvent' },
]

const List = ({
  state,
  handleOccurrenceClick,
  setState,
  fetchEventsList,
  setListDate,
  listDate,
  handleSortByChange,
  handleSingleEventClick,
  handleRegistrationClick,
  studentDetails,
}) => {
  return (
   
      <SectionWrapper>
        <Container column mTop={'10px'}>
          <LeftSection centerVertically>
            <StyledButton1
              onClick={() => handleOccurrenceClick('UPCOMING')}
              isSelected={state?.occurence == 'UPCOMING'}
            >
              Upcoming events
            </StyledButton1>
            <StyledButton1
              onClick={() => handleOccurrenceClick('PAST')}
              isSelected={state?.occurence == 'PAST'}
            >
              View all past events
            </StyledButton1>
          </LeftSection>
          <RightSection centerVertically>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '1rem',
              }}
            >
              <div>Sort by</div>
              <SelectField
                style={{ borderRadius: '5px', width: '160px' }}
                showArrow={true}
                options={sortByOption}
                valueParam="value"
                placeholder="Select"
                onChange={value => handleSortByChange(value)}
                showSearch={false}
                allowClear={true}
                selectedPlaceId={'sortByEvent'}
                textFieldHeight={'38px'}
                boxShadow={'0px 2px 6px 0px rgba(123, 97, 255, 0.15)'}
                border={'1px solid rgba(214, 219, 247, 1)'}
                value={state.sortBy}
              />
            </div>
          </RightSection>
        </Container>

        <UpcomingEvents
          state={state}
          setState={setState}
          fetchEventsList={fetchEventsList}
          setListDate={setListDate}
          listDate={listDate}
          handleSingleEventClick={handleSingleEventClick}
          handleRegistrationClick={handleRegistrationClick}
          studentDetails={studentDetails}
        />
      </SectionWrapper>
   
  )
}
export default List
